import { Person } from '@/interfaces/person';
import { PersonService } from '@/services/person/person.service';
import { BoxColors } from '@/shared/person-card/person-card.component';
import { Option } from '@/shared/select-list/select-list.component';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { switchMap, debounceTime, tap } from 'rxjs/operators';

@Component({
  selector: 'app-person-finder',
  templateUrl: './person-finder.component.html',
  styleUrls: ['./person-finder.component.css'],
})
export class PersonFinderComponent implements OnInit {

  @Input() controlForm: FormControl | AbstractControl = new FormControl(0);

  @Input() boxColor: BoxColors = BoxColors.WHITE;
  @Input() title: string = '';
  @Input() hintText: string = '';
  @Input() placeHolder: string = '';
  @Input() listPersonOptions: Option[] = [];
  @Input() optional: boolean = false;
  @Input() includeMyself: boolean = false;

  personForm: FormGroup = new FormGroup({
    filterText: new FormControl(''),
    id: new FormControl(-1),
  });

  selectedPersonData?: Person;

  loadingPersonOptions: boolean = false;

  constructor(
    private personService: PersonService,
    private cdr: ChangeDetectorRef,
  ) {

    const {
      filterText: filterText$,
    } = this.personForm.controls;

    filterText$.valueChanges
      .pipe(
        tap(() => {
          this.loadingPersonOptions = true;
        }),
        debounceTime(2000),
        switchMap((value) => this.personService.getFilteredList(value, this.includeMyself)),
      )
      .subscribe({
        next: (options) => {
          this.listPersonOptions = options;
          this.loadingPersonOptions = false;
          this.cdr.detectChanges();
        },
      });

  }

  ngOnInit() {
    this.controlForm.valueChanges.subscribe({
      next: (value) => {
        if (value === null) {
          this.selectedPersonData = undefined;
        }
        if (value) {
          this.personService.getPersonDataById(value).subscribe({
            next: (personData) => {
              this.selectedPersonData = personData;
              this.personForm.patchValue({ id: +value });
            },
          });
        }
      },
    });
  }

  onSearchPersonTextChange(text: string) {
    this.personForm.patchValue({ filterText: text });
  }

  onSearchPersonSelected(id: string) {
    this.personForm.patchValue({ id: +id });
    if (id) {
      this.personService.getPersonDataById(id).subscribe({
        next: (personData) => {
          this.selectedPersonData = personData;
          this.controlForm.patchValue(+id);
        },
      });
    }
  }

  onUnselect() {
    this.personForm.patchValue({ id: -1, filterText: '' });
    this.controlForm.patchValue(0);
    this.selectedPersonData = undefined;
    this.listPersonOptions = [];
  }

}
